import styled from 'styled-components';

export const AccordionPanelWrapper = styled.div`
  position: relative;
`;
